import Reveal from "@/components/Reveal";
import { DRIVES, EVENTS, HERO_IMAGES } from "@/data/site";

function Gallery({ items, testIdPrefix }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
      {items.map((it, idx) => (
        <Reveal key={`${testIdPrefix}-${idx}`} delay={(idx % 4) * 70}>
          <a
            href={it.img}
            target="_blank"
            rel="noreferrer"
            data-testid={`${testIdPrefix}-${idx}`}
            className="block group"
          >
            <div className="tile aspect-square">
              <img src={it.thumb || it.img} alt={it.caption} className="w-full h-full object-cover" loading="lazy" />
            </div>
            <div className="mt-3 text-xs uppercase tracking-[0.18em] text-[color:var(--ink-muted)] group-hover:text-[color:var(--brg)] transition">
              {it.caption}
            </div>
          </a>
        </Reveal>
      ))}
    </div>
  );
}

export default function Drives() {
  return (
    <div data-testid="drives-page">
      <section className="relative overflow-hidden border-b border-[color:var(--accent)]">
        <div className="absolute inset-0">
          <img src={HERO_IMAGES.convoy} alt="Sunday convoy" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-[color:var(--bg)] via-[color:var(--bg)]/70 to-[color:var(--bg)]/30"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-40">
          <Reveal>
            <div className="eyebrow mb-6">Sunday Group Drives & Events</div>
            <h1 className="font-display text-6xl md:text-8xl tracking-tighter leading-[0.95] max-w-4xl">
              Donuts, dawn, and <span className="italic text-[color:var(--brg)]">downshifts.</span>
            </h1>
            <p className="mt-10 max-w-2xl text-lg text-[color:var(--ink-secondary)]">
              From Glencoe parking lots at sunrise to Geneva Concours podiums — every gathering keeps the cars moving and the friendships warm.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="parchment">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
          <Reveal>
            <div className="flex items-end justify-between flex-wrap gap-4 mb-12">
              <div>
                <div className="eyebrow mb-3">No. 01</div>
                <h2 className="font-display text-4xl md:text-5xl tracking-tight">Sunday Group Drives</h2>
              </div>
              <span className="text-sm text-[color:var(--ink-muted)]">{DRIVES.length} moments</span>
            </div>
          </Reveal>
          <Gallery items={DRIVES} testIdPrefix="drive-photo" />
        </div>
      </section>

      <section className="border-t border-[color:var(--accent)] bg-[color:var(--surface)]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
          <Reveal>
            <div className="flex items-end justify-between flex-wrap gap-4 mb-12">
              <div>
                <div className="eyebrow mb-3">No. 02</div>
                <h2 className="font-display text-4xl md:text-5xl tracking-tight">Special Events & Shows</h2>
              </div>
              <span className="text-sm text-[color:var(--ink-muted)]">{EVENTS.length} appearances</span>
            </div>
          </Reveal>
          <Gallery items={EVENTS} testIdPrefix="event-photo" />
        </div>
      </section>
    </div>
  );
}
